/*
 * Mapa Home — Ürün galerisi PhotoSwipe zoom entegrasyonu
 * Ana ürün görseline tıklayınca alttan thumbnail şeritli, zoom'lu lightbox açar.
 * Masaüstü: tıkla ile yakınlaş/uzaklaş + görünür +/- butonları, mouse tekerleği, sürükle.
 * Mobil: pinch (iki parmak), çift dokunma ile zoom, kaydırarak görseller arası geçiş.
 *
 * PhotoSwipe core (photoswipe.esm.js) ESM modül olarak dinamik yüklenir.
 * Bu dosya bir <script type="module"> üzerinden, asset URL'leri data-attribute ile verilerek başlatılır.
 */

(function () {
  'use strict';

  const FOREST_GREEN = '#0A3D2C';

  function init(config) {
    const sectionId = config.sectionId;
    const gallery = document.getElementById('MediaGallery-' + sectionId);
    if (!gallery) return;

    // Sadece görsel medyalardan oluşan slide listesini kur.
    // Her ana galeri görseli .product__modal-opener--image içinde bulunur.
    const mediaItems = Array.from(
      gallery.querySelectorAll('.product__media-item')
    );

    const dataSource = [];
    const slideElementMap = []; // dataSource index -> tetikleyici <li> elementi

    mediaItems.forEach((li) => {
      const img = li.querySelector('.product__modal-opener--image img');
      if (!img) return; // video / 3D model atla

      // En yüksek çözünürlüklü kaynağı srcset'ten çek
      let largeSrc = img.currentSrc || img.src;
      let w = 1946; // image_url width: 1946 ile üretiliyor

      if (img.srcset) {
        const candidates = img.srcset
          .split(',')
          .map((s) => {
            const parts = s.trim().split(/\s+/);
            return { url: parts[0], w: parseInt(parts[1], 10) || 0 };
          })
          .filter((c) => c.url);
        if (candidates.length) {
          candidates.sort((a, b) => b.w - a.w);
          largeSrc = candidates[0].url;
          if (candidates[0].w) {
            w = candidates[0].w;
          }
        }
      }

      // Gerçek en/boy oranı: container'daki --ratio (media.aspect_ratio) veya attribute
      const container = li.querySelector('.product-media-container');
      let aspect = 0;
      if (container) {
        aspect = parseFloat(
          getComputedStyle(container).getPropertyValue('--ratio').trim()
        ) || 0;
      }
      const attrW = parseInt(img.getAttribute('width'), 10) || 0;
      const attrH = parseInt(img.getAttribute('height'), 10) || 0;
      if (!aspect && attrW && attrH) aspect = attrW / attrH;
      if (!aspect) aspect = 1;

      const h = Math.round(w / aspect);

      dataSource.push({
        src: largeSrc,
        width: w,
        height: h,
        alt: img.getAttribute('alt') || '',
        msrc: img.currentSrc || img.src,
        thumbSrc: largeSrc
      });
      slideElementMap.push(li);
    });

    if (dataSource.length === 0) return;

    let lightbox = null;
    let pswpInstance = null;

    function openAt(index) {
      import(config.pswpCoreUrl).then((module) => {
        const PhotoSwipe = module.default;

        pswpInstance = new PhotoSwipe({
          dataSource: dataSource,
          index: index,
          bgOpacity: 1,
          showHideAnimationType: 'fade',
          // Slide'lar arası boşluğu SIFIRLA — biriken yatay kaymanın kökü buydu
          // (varsayılan 0.1, her slide'a viewport×0.1 ekleyip son slide'larda kaydırıyordu)
          spacing: 0,
          tapAction: 'zoom',
          imageClickAction: 'zoom',
          doubleTapAction: 'zoom',
          wheelToZoom: true,
          maxZoomLevel: 4,
          pswpModule: PhotoSwipe
        });

        registerUI(pswpInstance);
        buildThumbStrip(pswpInstance);

        // KAYMA DÜZELTMESİ (canlıda doğrulandı):
        // Tarayıcı, slide değişiminde focus verilen elemana SMOOTH otomatik scroll
        // uyguluyor; bu .pswp__scroll-wrap'i kademeli olarak yatayda kaydırıyor
        // (scrollLeft birikerek artar) ve görselleri sola itiyordu.
        // change event'inde tek sıfırlama yetmez (scroll animasyonu sonradan gelir).
        // Çözüm: scroll event'inin KENDİSİNİ dinleyip her tetiklendiğinde anında geri al.
        pswpInstance.on('afterInit', () => {
          const sw = pswpInstance && pswpInstance.scrollWrap;
          if (!sw) return;
          const lock = () => {
            if (sw.scrollLeft !== 0 || sw.scrollTop !== 0) {
              sw.scrollLeft = 0;
              sw.scrollTop = 0;
            }
          };
          sw.addEventListener('scroll', lock, { passive: true });
          lock();
        });

        pswpInstance.on('destroy', () => {
          pswpInstance = null;
        });

        pswpInstance.init();
      });
    }

    // --- Masaüstü +/- zoom butonları ---
    function registerUI(pswp) {
      pswp.on('uiRegister', () => {
        const isDesktop = window.matchMedia('(min-width: 990px)').matches;
        if (!isDesktop) return;

        pswp.ui.registerElement({
          name: 'zoom-out-btn',
          order: 8,
          isButton: true,
          html: '&#8722;', // minus
          title: 'Uzaklaştır',
          onClick: () => stepZoom(pswp, -1)
        });

        pswp.ui.registerElement({
          name: 'zoom-in-btn',
          order: 9,
          isButton: true,
          html: '&#43;', // plus
          title: 'Yakınlaştır',
          onClick: () => stepZoom(pswp, 1)
        });
      });
    }

    function stepZoom(pswp, dir) {
      const slide = pswp.currSlide;
      if (!slide) return;
      const factor = dir > 0 ? 1.5 : 1 / 1.5;
      let dest = slide.currZoomLevel * factor;
      const min = slide.zoomLevels.fit;
      const max = slide.zoomLevels.max;
      dest = Math.max(min, Math.min(max, dest));
      const centerPoint = {
        x: pswp.viewportSize.x / 2,
        y: pswp.viewportSize.y / 2
      };
      slide.zoomTo(dest, centerPoint, 333);
    }

    // --- Alttaki thumbnail şeridi ---
    function buildThumbStrip(pswp) {
      pswp.on('uiRegister', () => {
        pswp.ui.registerElement({
          name: 'mapa-thumbs',
          appendTo: 'wrapper',
          onInit: (el) => {
            el.classList.add('mapa-pswp-thumbs');

            dataSource.forEach((item, i) => {
              const btn = document.createElement('button');
              btn.type = 'button';
              btn.className = 'mapa-pswp-thumb';
              btn.setAttribute('aria-label', 'Görsel ' + (i + 1));
              const thumbImg = document.createElement('img');
              thumbImg.src = item.thumbSrc || item.msrc || item.src;
              thumbImg.alt = item.alt;
              thumbImg.loading = 'lazy';
              btn.appendChild(thumbImg);
              btn.addEventListener('click', () => {
                pswp.goTo(i);
              });
              el.appendChild(btn);
            });

            const sync = () => {
              const thumbs = el.querySelectorAll('.mapa-pswp-thumb');
              thumbs.forEach((t, i) => {
                t.classList.toggle('is-active', i === pswp.currIndex);
              });
              const active = thumbs[pswp.currIndex];
              if (active) {
                active.scrollIntoView({
                  behavior: 'smooth',
                  inline: 'center',
                  block: 'nearest'
                });
              }
            };

            sync();
            pswp.on('change', sync);
          }
        });
      });
    }

    // --- Galeri tıklamalarını yakala ---
    mediaItems.forEach((li) => {
      const opener = li.querySelector('.product__modal-opener--image');
      if (!opener) return;

      const idx = slideElementMap.indexOf(li);
      if (idx === -1) return;

      // Dawn'ın native modal-opener davranışını devre dışı bırak
      opener.addEventListener(
        'click',
        (e) => {
          e.preventDefault();
          e.stopPropagation();
          openAt(idx);
        },
        true
      );
    });
  }

  // Sayfadaki tüm photoswipe-etkin galerileri başlat
  function boot() {
    document
      .querySelectorAll('[data-mapa-pswp]')
      .forEach((node) => {
        try {
          init({
            sectionId: node.getAttribute('data-section-id'),
            pswpCoreUrl: node.getAttribute('data-pswp-core')
          });
        } catch (err) {
          console.error('Mapa PhotoSwipe init error:', err);
        }
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
